import { getGetChannelsApiV1QueryKey } from "@/api/__generated__/api.schema";
import { env } from "@/constants/env";
import { Typography } from "@backpac/monica";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

export function OauthCallbackTiktokPage() {
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  const code = searchParams.get("code");
  const state = searchParams.get("state");

  useEffect(() => {
    if (!code || !state) {
      setError("Missing required parameters");
      return;
    }

    const handleCallback = async () => {
      try {
        const { workspaceId, returnUrl } = JSON.parse(state);
        await fetch(`${env.API_BASE}/api/v1/workspaces/${workspaceId}/channels/tiktok/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            code,
            redirectUri: returnUrl,
          }),
        });

        await queryClient.refetchQueries({ queryKey: getGetChannelsApiV1QueryKey(workspaceId) });
        window.close();
      } catch (error) {
        console.error(error);
        setError(error instanceof Error ? error.message : "An unknown error occurred");
      }
    };
    handleCallback();
  }, [code, state, queryClient]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      {error ? (
        <div className="text-center">
          <Typography size="lg" color="textPrimary" weight={600}>
            {error}
          </Typography>
          <div className="mt-4">
            <button
              type="button"
              className="px-4 py-2 bg-primary text-white rounded"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
          </div>
        </div>
      ) : (
        <div className="text-center">
          <Typography size="lg" weight={600}>
            Connecting with TikTok...
          </Typography>
          <div className="mt-4">
            <div className="animate-spin h-10 w-10 border-4 border-primary border-t-transparent rounded-full mx-auto" />
          </div>
        </div>
      )}
    </div>
  );
}
